import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { HubConnection, IHttpConnectionOptions } from '@microsoft/signalr';
import { environment } from 'environments/environment';
import { map, mergeMap } from 'rxjs';

const signalR = require("@microsoft/signalr");

@Injectable({ providedIn: 'root' })
export class SignalRService {
    constructor(private _httpClient: HttpClient) {
    }

    private GetAccessToken() {
        let httpheader = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        let data = {
            "client_id": environment.signalRClientId,
            "client_secret": environment.signalRClientSecret,
            "audience": `${environment.oDataUrl}/`,
            "grant_type": "client_credentials"
        };

        return this._httpClient.post(environment.signalRAuthUrl, data, httpheader)
    }

    private GetConnection(hubName: string) {
        return new signalR.HubConnectionBuilder()
                .configureLogging(signalR.LogLevel.None)
                .withUrl(`${environment.oDataUrl}/${hubName}`)
                .build();
        
    }

    GoodsInboundHub() {
        return this.GetConnection('GoodsInboundHub');
    }

    StatusScanningGoodsInboundHub() {
        return this.GetConnection('StatusScanningGoodsInboundHub');
    }
}